(ns ui.editor2.sidebar-music
  (:require [storrito.editor.sticker-design :as sticker-design]
            [ui.editor2.common :as common]))

(def instagram-styles
  [{:display-type "MUSIC_OVERLAY_SIMPLE"
    :label "Simple"}
   {:display-type "MUSIC_OVERLAY_ALBUM_ART"
    :label "Album Art"}
   {:display-type "MUSIC_VINYL"
    :label "Vinyl"}])

(defn music-edit-sidebar
  [state]
  (let [selected-asset (:clip/asset (common/get-selected-clip state))
        selected-display-type (get-in selected-asset
                                      [:asset/data :display-type])]
    [:div
     {:class ["flex" "flex-col" "gap-2" "w-full"]}

     [:button.w-full.flex.items-center.justify-center.bg-gray-500.rounded-md.p-2
      {:type "button"
       :on {:click [[:data/query {:query/kind :query/ig-account-data}]
                    [:ui/modal-open
                     :modals/editor2-music-modal
                     (select-keys selected-asset [:asset/data
                                                  :asset/uuid
                                                  :db/id])]]}}
      [:span.hidden.lg:block.ml-2
       "Change Song"]]

     [:div
      {:class ["flex" "flex-col" "w-full"]}
      [:span
       {:class ["text-xs" "font-medium"]}
       "Instagram styles"]
      [:span
       {:class ["text-xs" "text-gray-400"]}
       "(animated visual, rendered by Instagram on the story)"]]

     [:ul.grid.grid-cols-1.gap-6.lg:grid-cols-1
      (map
        (fn [{:keys [display-type label]}]
          [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200.bg-white
           [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
            {:type "button"
             :class (when (= display-type
                             selected-display-type)
                      ["outline" "outline-2" "outline-purple-700"])
             :on {:click [[:editor2/set-asset-display-type display-type]
                          [:editor2/prepare-assets!]]}}
            [:span
             {:style {:fontSize "30px"
                      :fontFamily "Instagram Sans Condensed"
                      :color "#d300c5"}}
             [:i.fas.fa-music.mr-2]
             label]]])
        instagram-styles)]

     (common/invisible-design-section
       {:design sticker-design/invisible-music-design
        :text "INVISIBLE"})]))
